exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".role-overlay[data-v-152e228c]{position:absolute;top:45px;right:-25px;height:140px;width:200px;z-index:15;color:#fff}.role-overlay.disabled[data-v-152e228c]{display:none;pointer-events:none;cursor:default}.node-icon-holder[data-v-152e228c]{height:70px;width:70px;position:absolute;display:flex;justify-content:center;align-items:center;top:0;margin-left:60px;margin-top:5px}.node-icon[data-v-152e228c]{margin:auto;width:70px;-webkit-filter:drop-shadow(2px 2px 2px #222);filter:drop-shadow(2px 2px 2px #222)}.blue-bar[data-v-152e228c]{position:absolute;top:60px;left:-10px;right:0;bottom:0;margin:auto}.title-holder[data-v-152e228c]{position:absolute;top:55px;left:40px;right:50px;bottom:0;margin:auto;height:30px;width:110px}.title[data-v-152e228c]{font-weight:400;margin:2px;text-align:center;font-size:12px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"id":"data-v-152e228c","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/RoleOverlay.vue
// module id = 72
// module chunks = 0